import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/research-bar/embed')({
  beforeLoad: () => {
    throw redirect({ to: '/recherche/integration', replace: true })
  },
})
